export const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
};

export const FORM_ID = "change-password-form";

export const CHANGE_PASSWORD_API_PATH = "/api/auth/change-password";

export const TOAST_DURATION = 3000;
